export const Enum_UpdateCustomer = [
  'customerId',
  'customerFullName',
  'customerName',
  'customerDepartId',
  'province',
  'city',
  'district',
  'address',
  'customerLevel',
  'managerId',
  'chargeManagerIds',
  'journalerId',
  'taxerId',
  'auditerIds',
  'consultanterIds',
  'businessType'
]

export const enum_subject = [
  'beanId',
  'code',
  'pCode',
  'name',
  'enabled',
  'direction',
  'subjectId',
  'beanType',
  'assistantsType'
] 

export const enum_UpdateContract = [
  'pactId',
  'referrer',
  'modSerialNum',
  'signUserId',
  'signDate',
  'pactStartTime',
  'pactEndTime',
  'isAutoExtend',
  'handingVoucherType',
  'pactRemark',
  'customerId'
]


// WEBPACK FOOTER //
// ./src/util/paramsConfig.js